import Vue from 'vue'
import Router from 'vue-router'
import AquaCulture from '@/components/AquaCulture'
import Query from '@/components/userData/Query'
import AllNum from '@/components/userData/AllNum'
import downLoad from '@/components/userData/downLoad'
import alarmLog from '@/components/userData/alarmLog'
import manualControl from '@/components/userData/manualControl'
import automatic from '@/components/userData/Automatic'
import controlLog from '@/components/userData/controlLog'
import startAndStopLog from '@/components/userData/startAndStopLog'
import termInfo from '@/components/termInfo'
import Analysis from '@/components/userData/analysisData'
import AddPond from '@/components/setting/addPond'
import AddTerm from '@/components/setting/addTerm'
import AddSensor from '@/components/setting/addSensor'
import AddEquip from '@/components/setting/addEquip'
import chgPassword from '@/components/setting/chgPassword'
import Cell from '@/components/control/cell'
import Term from '@/components/control/term'
import checkData from '@/components/admin/checkData'
import analysisData from '@/components/admin/analysisData'
import contrastData from '@/components/admin/contrastData'
import onlineDevice from '@/components/admin/onlineDevice'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  base: '/Water',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/AquaCulture',
      name: 'AquaCulture',
      component: AquaCulture,
      children: [
        { path: '/Query/:pond_name/:pond_id', name: 'Query', component: Query },
        { path: '/AllNum/:pond_name/:pond_id/:name', name: 'AllNum', component: AllNum },
        { path: '/Analysis', name: 'Analysis', component: Analysis },
        { path: '/AddPond', name: 'AddPond', component: AddPond },
        { path: '/AddTerm', name: 'AddTerm', component: AddTerm },
        { path: '/termInfo', name: 'termInfo', component: termInfo },
        { path: '/AddSensor', name: 'AddSensor', component: AddSensor },
        { path: '/AddEquip', name: 'AddEquip', component: AddEquip },
        { path: '/chgPassword', name: 'chgPassword', component: chgPassword },
        { path: '/checkData', name: 'checkData', component: checkData },
        { path: '/analysisData', name: 'analysisData', component: analysisData },
        { path: '/contrastData', name: 'contrastData', component: contrastData },
        { path: '/onlineDevice', name: 'onlineDevice', component: onlineDevice },
        { path: '/Cell', name: 'Cell', component: Cell },
        { path: '/Term', name: 'Term', component: Term },
        { path: '/downLoad', name: 'downLoad', component: downLoad },
        { path: '/alarmLog', name: 'alarmLog', component: alarmLog },
        { path: '/manualControl', name: 'manualControl', component: manualControl },
        { path: '/automatic', name: 'automatic', component: automatic },
        { path: '/controlLog', name: 'controlLog', component: controlLog },
        { path: '/startAndStopLog', name: 'startAndStopLog', component: startAndStopLog }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js